export const LoanAmountDetails = [
  { id: 1, value: 7000, amount: "BZD 7,000" },
  { id: 2, value: 10000, amount: "BZD 10,000" },
  { id: 3, value: 15000, amount: "BZD 15,000" },
  { id: 4, value: 20000, amount: "BZD 20,000" },
  { id: 5, value: 25000, amount: "BZD 25,000" },
  { id: 6, value: 30000, amount: "BZD 30,000" },
]
